type NotFoundLocationState = { is404: true };

type LocationLike = { state?: unknown };

type NotFoundLocation = LocationLike & { state: NotFoundLocationState };

export function isNotFoundLocation(location: LocationLike): location is NotFoundLocation {
  return (
    location.state !== null &&
    typeof location.state === 'object' &&
    'is404' in location.state &&
    location.state.is404 === true
  );
}
